import FullViewLoading from 'components/common/FullViewLoading';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

export function ThemesOutlet() {
  return (
    <Suspense fallback={<FullViewLoading title="Loading themes..." />}>
      <Outlet />
    </Suspense>
  );
}
